import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border rounded-pill d-flex flex-row align-items-center" }
const _hoisted_2 = { class: "me-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex-fill d-flex flex-column align-items-center" }
const _hoisted_5 = { class: "text-dark fw-bold fs-5 lh-1 text-nowrap" }
const _hoisted_6 = { class: "small text-muted text-nowrap" }
const _hoisted_7 = {
  key: 0,
  class: "small text-muted text-nowrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.profilePicture,
        class: "avatar avatar-sm rounded-circle img-fluid border gtr-avatar-bg"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user.nickname), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.username), 1),
      (_ctx.rankName(_ctx.user.currentRank))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_rank_icon, {
              "icon-class": _ctx.rankIconClass(_ctx.user.currentRank),
              "extra-class": "ps-2 pe-1 small"
            }, null, 8, ["icon-class"]),
            _createTextVNode(_toDisplayString(_ctx.rankName(_ctx.user.currentRank)) + " ", 1),
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa-fw ps-3 small" }, null, -1))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}